import React from 'react';
import hero_img from '../../img/bg_hero1.jpg'
import logo_img from '../../img/logo192.png'
const HeroBanner = () => {
    return (
<div className="hero min-h-screen bg-fixed" style={{ backgroundImage: `url(${hero_img})` }}>
  <div className="hero-overlay bg-opacity-60"></div>
  <div className="hero-content text-center text-neutral-content">
    <div className="max-w-md">
      <img className=' mx-auto' src={logo_img} alt="" />
      <h1 className="mb-5 text-5xl font-bold "> Quality is Priority </h1>
      <p className="mb-5"> We are the best construction tools manufacturer, Our Focus on quality for safety and for earning your trust  </p>
      {/* <button className="btn bg-[#FD4475] border-0">Get Started</button> */}
    </div>
  </div>
</div>
    );
};

export default HeroBanner;